// Logo 6A, "Puntos en ruta": four dots growing along a route to a sand
// destination. Geometry on a 100×100 grid; mirrors `public/monogram*.svg` and
// mobile's `GromlyLogo`.
export const MARK_DOTS = [
  { cx: 20, cy: 78, r: 5 },
  { cx: 31, cy: 53, r: 6.5 },
  { cx: 51, cy: 34, r: 8.5 },
] as const;
export const MARK_DEST = { cx: 78, cy: 26, r: 11 } as const;
export const MARK_OFFSET = 'translate(-2,1)';

export const INK = '#0b1420';
export const CREAM = '#faf7f0';
export const DEST_SAND = '#c68642';

type Tone = 'ink' | 'light' | 'mono';
const DOT: Record<Tone, string> = { ink: INK, light: CREAM, mono: 'currentColor' };

interface Props {
  size?: number;
  /** `ink` on light backgrounds, `light` on dark ones, `mono` takes the text colour. */
  tone?: Tone;
  className?: string;
  /** Decorative next to a visible "Gromly" wordmark. */
  decorative?: boolean;
}

export function GromlyMark({ size = 24, tone = 'ink', className, decorative }: Props) {
  const c = DOT[tone];
  const dest = tone === 'mono' ? 'currentColor' : DEST_SAND;
  return (
    <svg
      viewBox="0 0 100 100" width={size} height={size} className={className}
      {...(decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': 'Gromly' })}
    >
      <g transform={MARK_OFFSET}>
        {MARK_DOTS.map(d => <circle key={d.cx} {...d} fill={c} />)}
        <circle {...MARK_DEST} fill={dest} />
      </g>
    </svg>
  );
}

/** Mark + "Gromly" set as HTML text (Fraunces italic 300, opsz 144), so it
 *  doesn't depend on the SVG `<text>` finding the font. */
export function GromlyWordmark({ size = 24, dark, className }: { size?: number; dark?: boolean; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ''}`}>
      <GromlyMark size={size} tone={dark ? 'light' : 'ink'} decorative />
      <span
        className="font-serif italic leading-none tracking-[-0.01em]"
        style={{
          fontWeight: 300,
          fontVariationSettings: "'opsz' 144",
          fontSize: Math.round(size * 0.92),
          color: dark ? CREAM : INK,
        }}
      >
        Gromly
      </span>
    </span>
  );
}
